<article class="booking-slot-step-card">
    <header class="booking-slot-step-header vstack gap-1">
        <h2
            #heading
            class="booking-step-heading h4 fw-semibold m-0"
            tabindex="-1"
        >
            {{ customerChoosesArea() ? 'Select Area & Time' : 'Select a Time' }}
        </h2>
    </header>

    <div class="booking-slot-area-list vstack gap-3">
        @for (group of groups(); track $index; let index = $index) {
            <app-venue-storefront-booking-area-slots
                [group]="group"
                [idealTime]="idealTime()"
                [selectedSlot]="selectedSlot()"
                [collapsible]="groups().length > 1"
                [cardId]="'booking-area-' + index"
                (slotSelected)="slotSelected.emit($event)"
                (waitlistSlotSelected)="waitlistSlotSelected.emit($event)"
                (joinWaitlistRequested)="joinWaitlistRequested.emit()"
            />
        }
    </div>
</article>
